import { T, always, cond, either, isNil, propSatisfies } from 'ramda';
import cc from 'classcat';

import { fromCents } from '#src/lib/formatters/numbers';

import styles from './styles.module.scss';

const trialText = cond([
  [
    either(propSatisfies(isNil, 'value'), propSatisfies(isNil, 'unit')),
    always(''),
  ],
  [T, ({ unit, value }) => `Free ${value}-${unit} trial`],
]);

export const MembershipItem = ({
  amount,
  isFreeTrial,
  selectedPaymentPlan,
}) => {
  const subscription = selectedPaymentPlan?.subscription;
  const hasTrialInformation = !!subscription && isFreeTrial;
  const orderTitle = hasTrialInformation
    ? trialText(subscription.trialDuration)
    : 'WayBetter Membership';

  return (
    <>
      <h2 className={styles.title}>{orderTitle}</h2>
      <span className={cc([styles.title, styles.emphasized, styles.amount])}>
        {fromCents(amount)}
      </span>
    </>
  );
};
